export const drawerSlideProps = {
	direction: "down" as const,
	mountOnEnter: true,
	unmountOnExit: true,
	timeout: {
		enter: 500,
		exit: 400,
	},
};
